import Layout from '@/layout';
import { roterPre } from '@/settings';
var orderRouter = {
  path: "".concat(roterPre, "/order"),
  name: 'order',
  meta: {
    icon: 'dashboard',
    title: '订单'
  },
  alwaysShow: true,
  component: Layout,
  redirect: 'noRedirect',
  children: [{
    path: 'list',
    name: 'OrderList',
    meta: {
      title: '订单管理'
    },
    component: function component() {
      return import('@/views/order/index');
    }
  }, {
    path: 'refund',
    name: 'OrderRefund',
    meta: {
      title: '退款单'
    },
    component: function component() {
      return import('@/views/order/orderRefund/index');
    }
  }, {
    path: 'invoice',
    name: 'OrderInvoice ',
    meta: {
      title: '发票管理'
    },
    component: function component() {
      return import('@/views/order/orderInvoice/index');
    }
  }, {
    path: 'cancellation',
    name: 'OrderCancellation',
    meta: {
      title: '核销订单'
    },
    component: function component() {
      return import('@/views/order/orderCancellate/index');
    }
  }, {
    path: 'print',
    name: "OrderPrint",
    meta: {
      title: '配货单打印',
      fullScreen: true
    },
    component: function component() {
      return import('@/views/order/print/index');
    }
  }, {
    path: 'customer',
    name: "CustomerOrder",
    meta: {
      title: '代客下单',
      fullScreen: true
    },
    component: function component() {
      return import('@/views/customerOrder/index');
    }
  }, {
    path: 'reservation',
    name: "Reservation",
    meta: {
      title: '预约服务'
    },
    component: function component() {
      return import('@/views/order/orderReservation/index');
    }
  }]
};
export default orderRouter;